var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.333 10a.75.75 0 0 1 1.5 0c0 2.063.525 2.683 1.005 2.938.289.154.665.237 1.166.273.518.039 1.035.024 1.68.039h2.798c.644-.015 1.161 0 1.68-.039.5-.036.877-.119 1.166-.273.48-.255 1.005-.875 1.005-2.938a.75.75 0 0 1 1.5 0c0 2.26-.58 3.613-1.8 4.262-.559.299-1.18.403-1.76.446-.564.041-1.213.029-1.756.042H6.648c-.542-.013-1.192 0-1.755-.042-.58-.043-1.201-.147-1.761-.446-1.22-.65-1.8-2.002-1.8-4.262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.552 8.197a.75.75 0 0 1 1.061-1.06l1.72 1.72V2a.75.75 0 0 1 1.5 0v6.856l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.004.053l-.057-.052z"
  })));
};
export default Svg16;